// extracted by mini-css-extract-plugin
module.exports = {"legend-container":"XtQZPsymjRn9OzJzK+XyrA==","legend-entry":"_5lV67hs+E-cz3uGFLqvj5g==","legend-marker":"seuK5J6UT-OKo0pSD-lNxA==","legend-text":"XeP8zhuUUKrLrKHduGKz8g=="};